/** 
 * @Desc: 课件视频点击区域
 */
<template>
  <keep-alive>
    <div v-if="videoInfo.i" class="video-click-area clickable" :style="videoAreaStyle"></div>
  </keep-alive>
</template>

<script type="text/ecmascript-6">
export default {
  name: "VideoClickArea",
  props: {
    // 视频信息
    videoInfo: {
      type: Object,
      required: true
    },
    // 元素大小及位置
    otherParams: {
      type: Object,
      default: () => {
        return {
          top: 0,
          left: 0,
          w: 960,
          h: 540,
          w_actual: 960,
          h_actual: 540
        };
      }
    }
  },
  computed: {
    videoAreaStyle: function() {
      let style = {};
      const height =
        (this.otherParams.w / this.otherParams.w_actual) *
        this.otherParams.h_actual;
      const w_coefficient = this.otherParams.w / this.otherParams.w_actual;
      const h_coefficient = this.otherParams.h / this.otherParams.h_actual;
      style.top =
        this.videoInfo.t * h_coefficient + this.otherParams.top + "px";
      style.left =
        this.videoInfo.l * w_coefficient + this.otherParams.left + "px";
      style.width = this.videoInfo.w * w_coefficient + "px";
      style.height = this.videoInfo.h * h_coefficient + "px";
      // console.log(this.videoInfo, this.otherParams,style, w_coefficient, h_coefficient);

      // const height = this.width / 16 * 9
      // style.top = this.videoInfo.t / 540 * height + 'px'
      // style.left = this.videoInfo.l / 960 * this.width + 'px'
      // style.width = this.videoInfo.w / 960 * this.width + 'px'
      // style.height = this.videoInfo.h / 540 * height + 'px'

      // style.top = this.videoInfo.t / this.otherParams.h * height + 'px';
      // style.left = this.videoInfo.l / this.otherParams.w * this.otherParams.w + 'px';
      // style.width = this.videoInfo.w / this.otherParams.w * this.otherParams.w + 'px';
      // style.height = this.videoInfo.h / this.otherParams.h * height + 'px';
      return style;
    }
  }
};
</script>

<style scoped lang="less" rel="stylesheet/less">
.video-click-area {
  position: absolute;
}
</style>
